module.exports = __webpack_public_path__ + "img/collect.51aa2947.svg";